import React from "react";
import { useParams } from 'react-router-dom';
import { getNewsById } from "../../constants/news-constant";
import { getOnlineNewsById } from "../../services/newsService";
import "./news.css";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import Page from "../../components/page/page";

function NewsDetail ()  {
    const params = useParams();
    const news = [...getOnlineNewsById(params.id)];

    return (
        <Page>
            <Header />
            <div className="container news-content">
                <div className=" row hrow ">
                    <figure className="figure">
                        <figcaption className="figure-caption">
                            <h3>
                                {news[0].title}
                            </h3>
                            <span className="time">انتشار توسط هوایار</span>
                        </figcaption>
                        <img src={`${news[0].imageUrl}`} className="figure-img img-fluid " alt="..." />
                    </figure>
                </div>
                <p className="hy-text-body blockquote">
                    {news[0].firstParagraph}
                </p>
                <p className="hy-text-body">
                    {news[0].totalDescrption}
                </p>
                <h5 className="text-title-body">جزییات خبر</h5>
                <p className="hy-text-body">
                    {news[0].briefDescription}
                </p>
                <span className="time">{news[0].relaseDate}</span>
            </div>
            <Footer />
        </Page>
    );
};

export default NewsDetail;
